import $ from "jquery";
import * as _ from "underscore";

import * as deviceDetect from "deviceDetect";
import * as modalDialog from "modalDialog";
import * as mustcache from "mustcache";
import * as utils from "shared/utils";

export const alert = (options) => {
  show(_.extend({ title: "Alert", icon: "warning-sign" }, options));
};

export const confirm = (options) => {
  const okButton = {
    name: "ok",
    displayName: options.ok || "OK",
  };

  const cancelButton = {
    name: "cancel",
    displayName: options.cancel || "Cancel",
    extraClass: "grey",
  };

  const confirmButtons = deviceDetect.is("windows")
    ? [okButton, cancelButton]
    : [cancelButton, okButton];

  show(
    _.extend(
      {
        icon: options.warning ? "warning-sign" : "question-sign",
        buttons: confirmButtons,
      },
      options
    )
  );
};

var show = (options) => {
  if (options.message) {
    options.messageHtml = utils.simpleMarkupToHtml(options.message);
  }
  mustcache.render("genericDialog", options, (html) => {
    const $dialog = $(html);
    modalDialog.show($dialog, {
      cancelCallback: () => {
        if (options.callback) {
          options.callback("cancel");
        }
      },
    });

    $dialog.find('button[name="ok"]').focus();

    $dialog.find("button[name]").click((event) => {
      modalDialog.cancel(null, true);
      options.callback($(event.target).attr("name"));
      delete options.callback;
    });
  });
};
